__turbopack_context__.v({
  "box": "selection-controls-module__s0hvcW__box",
  "boxCheck": "selection-controls-module__s0hvcW__boxCheck",
  "boxLg": "selection-controls-module__s0hvcW__boxLg",
  "boxRadio": "selection-controls-module__s0hvcW__boxRadio",
  "chip": "selection-controls-module__s0hvcW__chip",
  "chipGroup": "selection-controls-module__s0hvcW__chipGroup",
  "chipMark": "selection-controls-module__s0hvcW__chipMark",
  "choice": "selection-controls-module__s0hvcW__choice",
  "desc": "selection-controls-module__s0hvcW__desc",
  "dot": "selection-controls-module__s0hvcW__dot",
  "fieldset": "selection-controls-module__s0hvcW__fieldset",
  "input": "selection-controls-module__s0hvcW__input",
  "isDisabled": "selection-controls-module__s0hvcW__isDisabled",
  "isSelected": "selection-controls-module__s0hvcW__isSelected",
  "label": "selection-controls-module__s0hvcW__label",
  "legend": "selection-controls-module__s0hvcW__legend",
  "list": "selection-controls-module__s0hvcW__list",
  "listRow": "selection-controls-module__s0hvcW__listRow",
  "msg": "selection-controls-module__s0hvcW__msg",
  "msgError": "selection-controls-module__s0hvcW__msgError",
  "text": "selection-controls-module__s0hvcW__text",
  "tick": "selection-controls-module__s0hvcW__tick",
});
